// src/components/post/PostItem.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import PostAuthor from './PostAuthor';

const PostItem = ({ postID, category, title, description, authorID, createdAt, thumbnail }) => {
  // Keep your existing logic for shortening text
  const shortDescription = description.length > 145 ? description.substr(0, 145) + '...' : description;
  const postTitle = title.length > 30 ? title.substr(0, 30) + '...' : title;

  return (
    <article className="bg-white rounded-xl overflow-hidden shadow-md transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1">
      {/* Thumbnail */}
      <div className="overflow-hidden h-48">
        <Link to={`/posts/${postID}`} className="block h-full">
          <img
            src={`${process.env.REACT_APP_ASSETS_URL}/uploads/${thumbnail}`}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </Link>
      </div>
      
      {/* Content */}
      <div className="p-5">
        <Link to={`/posts/${postID}`}>
          <h3 className="text-xl font-bold text-gray-900 hover:text-primary transition-colors mb-2">
            {postTitle}
          </h3>
        </Link>
        
        <div 
          className="text-gray-600 text-sm mb-4"
          dangerouslySetInnerHTML={{__html: shortDescription}} 
        />
        
        <div className="flex justify-between items-center mt-4">
          {/* Author info */}
          <PostAuthor 
            authorID={authorID}
            createdAt={createdAt}
          />
          
          {/* Category */}
          <Link 
            to={`/posts/categories/${category}`}
            className="bg-primary bg-opacity-90 text-white text-xs font-semibold px-3 py-1 rounded-full hover:bg-opacity-100 transition-colors"
          >
            {category}
          </Link>
        </div>
      </div>
    </article>
  );
};

export default PostItem;